<template>
<div class="var-item">
  <div class="var-item-label" :style="{ 'min-width': model.lbl_width + 'px' }">{{ model.question }}</div>
  <div class="var-item-val">
    {{ val }}
  </div>
  <div class="var-item-unit">
    {{ model.unit }}
  </div>
  <div class="var-item-error" v-if="outlier">
    超出范围：{{ model.lower }} ~ {{ model.upper }} {{ model.unit }}
  </div>
</div>
</template>

<script>
export default {
  name: 'view-var',
  props: ['model'],
  computed: {
    val: function () {
      var val = this.model.data.val
      switch (this.model.type) {
        case 'radio':
          val = this.model.codes[this.model.data.val]
          break
        default:
          break
      }
      return val
    },
    outlier: function () {
      return this.model.data.val && (this.model.data.val < this.model.lower || this.model.data.val > this.model.upper)
    }
  }
}
</script>

<style scoped>
.var-item {
  width: 100%;
}
.var-item-label {
  display: inline-block;
}
.var-item-val {
  display: inline;
  padding: 0 5px 0 20px;
}
.var-item-unit {
  display: inline;
  padding: 0 5px 0 5px;
  font-weight: lighter;
  font-size: .8em;
}
.var-item-actions {
  display: inline;
  padding: 0px 20px 0 0;
  text-align: right;
  float: right;
  letter-spacing: 6px;
}
.var-item-error {
  font-size: .8em;
  padding-left: 20px;
  color: #d7400a;
}
</style>
